import { SAVE_PLATFORM_ID } from './actionTypes';

export function savePlatformId(payload: any) {
    return {
        type: SAVE_PLATFORM_ID,
        payload,
    };
}


// WEBPACK FOOTER //
// ./modules/platform-id-processor/actions/actions.ts